/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';

import Container from '../../../../components/Container';

const mock = [
  {
    title: 'Sourcing Labor',
    subtitle:
      'Recruiting funnels, trade school partnerships, referral loops, and job board automation to keep crews staffed.',
    icon: (
      <svg width={40} height={40} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    ),
  },
  {
    title: 'AI Software Solutions',
    subtitle:
      'Quoting assistants, work order triage, schedule optimization, and RFP drafting tuned to your workflows.',
    icon: (
      <svg width={40} height={40} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2-1.343-2-3-2z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2 12c0-5.523 4.477-10 10-10m0 20C6.477 22 2 17.523 2 12m20 0c0 5.523-4.477 10-10 10m0-20c5.523 0 10 4.477 10 10" />
      </svg>
    ),
  },
  {
    title: 'Logistics Planning',
    subtitle:
      'Routing, materials kitting, vendor SLAs, and last‑mile coordination to reduce idle time and callbacks.',
    icon: (
      <svg width={40} height={40} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7h13l5 5v5H3z" />
      </svg>
    ),
  },
  {
    title: 'Tailored Growth Strategies',
    subtitle:
      'Market positioning, channel testing, territory expansion, and profitability playbooks for blue‑collar leaders.',
    icon: (
      <svg width={40} height={40} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 11V3a1 1 0 112 0v8h4a1 1 0 110 2h-4v6a1 1 0 11-2 0v-6H7a1 1 0 110-2h4z" />
      </svg>
    ),
  },
];

const Features = () => {
    const theme = useTheme();

    return (
        <Box sx={{ position: 'relative' }}> {/* Full-width background */}
            <Container>
                <Box>
                    <Box marginBottom={4}>
                        <Typography
                            sx={{
                                textTransform: 'uppercase',
                                fontWeight: 'medium',
                            }}
                            gutterBottom
                            color={'text.secondary'}
                            align={'center'}
                        >
                            Why Partner with Skilled Strategies
                        </Typography>
                        <Typography
                            variant="h4"
                            align={'center'}
                            gutterBottom
                            sx={{
                                fontWeight: 700,
                            }}
                        >
                            Solutions built for blue‑collar companies
                        </Typography>
                        <Typography variant="h6" align={'center'} color={'text.secondary'}>
                            From staffing and logistics to AI‑enabled ops and go‑to‑market,
                            we deploy practical systems that improve utilization, win rates,
                            and margins.
                        </Typography>
                    </Box>
                    <Grid container spacing={4}>
                        {mock.map((item, i) => (
                            <Grid key={i} item xs={12} md={3}>
                                <ListItem
                                    component="div"
                                    disableGutters
                                    sx={{
                                        flexDirection: 'column',
                                        alignItems: 'flex-start',
                                        padding: 0,
                                    }}
                                >
                                    <Box
                                        component={ListItemAvatar}
                                        marginBottom={1}
                                        minWidth={'auto !important'}
                                    >
                                        <Box color={theme.palette.primary.main}>{item.icon}</Box>
                                    </Box>
                                    <ListItemText
                                        primary={item.title}
                                        secondary={item.subtitle}
                                        primaryTypographyProps={{
                                            variant: 'h6',
                                            gutterBottom: true,
                                            align: 'left',
                                        }}
                                        secondaryTypographyProps={{ align: 'left' }}
                                        sx={{
                                            '& .MuiListItemText-primary': {
                                                fontWeight: 700,
                                            },
                                            margin: 0,
                                        }}
                                    />
                                </ListItem>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

export default Features;